/**
 * Parses YYYY-MM-DD ONLY, as a plain date with no timezone.
 *
 * The format is similar to the RFC 9557 format:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainDate#rfc_9557_format
 * but without support for custom calendars.
 */
export function parseMaybeDateString(dateString: string | null): Date | null {
  if (!dateString) return null;
  return new Date(dateString + "T00:00:00"); // append time to ensure date is treated as local time
}
